'use client';

import { c as _c } from "react/compiler-runtime";
import { Text } from '@extern/ui/text';

/**
 * Shown on sign-in to someone we moved there from sign-up, because the address they typed already has an
 * account. Without a line like this the redirect is unexplained: they pressed a sign-up button and
 * arrived somewhere else.
 */
export function ExistingAccountNotice() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full rounded-2xl border border-role-info-outline bg-role-info-container/40 px-4 py-3" role="status"><Text body="md" className="text-role-on-background"><span className="font-medium">You already have an account.</span> Sign in below to continue.</Text></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}